import { useAuthStore } from "@/stores/authStore";

export function setupUnauthorizedSessionHandler(router) {
  window.addEventListener("auth:unauthorized", () => {
    const authStore = useAuthStore();
    authStore.logout();

    if (router.currentRoute.value.name !== "Login") {
      router.replace({ name: "Login" });
    }
  });
}
